var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "leftBox" }, [
    _c("div", { staticClass: "cockpitBox" }, [
      _c("div", { staticClass: "cockpit_header" }, [
        _c("div", { staticClass: "cockpit_header_bg" }, [
          _c("div", [
            _c("img", {
              attrs: { src: require("@/assets/img/cockpit/deng.png"), alt: "" },
            }),
          ]),
          _c("div", { staticClass: "header_title" }, [_vm._v("项目预警")]),
          _c("div", [
            _c("img", {
              attrs: { src: require("@/assets/img/cockpit/dian.png"), alt: "" },
            }),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "cockpit_content warning_box1" }, [
        _c("div", { staticClass: "left_left_box" }, [
          _c("div", { attrs: { id: "echartsData" } }),
          _c(
            "div",
            { staticClass: "rightFrequency" },
            _vm._l(_vm.trafficWay, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "rightFrequency_box" },
                [
                  _c("div", { style: { background: _vm.colorList[index] } }),
                  _c("div", [_vm._v(_vm._s(item.name))]),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.total > 0
                          ? ((item.value / _vm.total) * 100).toFixed(2) + "%"
                          : 0 + "%"
                      )
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
        _c(
          "div",
          { staticClass: "left_right_box" },
          _vm._l(_vm.warnData, function (item, index) {
            return _c("div", { key: index, staticClass: "warn_detail_box" }, [
              _c("div", { staticClass: "warn_detail_box_top" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/cockpit/warn/left_left.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "detail_middle" }, [
                  _c("div", { staticClass: "detail_middle_top" }, [
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(item.rate))]),
                      _vm._v(" %"),
                    ]),
                    _c("span"),
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(item.count))]),
                      _vm._v(" 条"),
                    ]),
                  ]),
                  _c("img", {
                    attrs: {
                      src: require(`@/assets/img/cockpit/warn/left${
                        index + 1
                      }.png`),
                      alt: "",
                    },
                  }),
                ]),
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/cockpit/warn/left_right.png"),
                    alt: "",
                  },
                }),
              ]),
              _c("div", { staticClass: "warn_detail_box_title" }, [
                _vm._v(_vm._s(item.name) + " "),
              ]),
            ])
          }),
          0
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "cockpitBox", staticStyle: { "margin-top": "16px" } },
      [
        _c("div", { staticClass: "cockpit_header" }, [
          _c("div", { staticClass: "cockpit_header_bg" }, [
            _c("div", [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/cockpit/deng.png"),
                  alt: "",
                },
              }),
            ]),
            _c("div", { staticClass: "header_title" }, [
              _vm._v("项目预警信息"),
            ]),
            _c("div", [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/cockpit/dian.png"),
                  alt: "",
                },
              }),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "cockpit_content warning_box2" }, [
          _c("div", { staticClass: "warn-color" }, [
            _c("div", { staticClass: "warn-flex" }, [
              _c(
                "div",
                { staticClass: "flex-left" },
                _vm._l(_vm.count, function (item, index) {
                  return _c("span", { key: index }, [
                    _c("b", [_vm._v(_vm._s(item.count))]),
                    _vm._v("条 " + _vm._s(item.gradeName) + " "),
                  ])
                }),
                0
              ),
              _c("div", { staticClass: "flex-right" }, [
                _c("span", [_c("b", [_vm._v(_vm._s(_vm.countTotal))])]),
              ]),
            ]),
            _c("div", { staticClass: "color-list" }, [
              _c(
                "div",
                { staticClass: "color" },
                _vm._l(_vm.count, function (item, index) {
                  return _c("span", {
                    key: index,
                    style: {
                      width: (item.count / _vm.countTotal) * 100 + "%",
                      background: _vm.dealColorFn(item.gradeType).color,
                    },
                  })
                }),
                0
              ),
              _c(
                "span",
                { staticStyle: { color: "rgba(255, 255, 255, 0.65)" } },
                [_vm._v("待处理数")]
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "warn_content" },
            _vm._l(_vm.cardData, function (items, indexs) {
              return _c("div", { key: indexs }, [
                _c("div", { staticClass: "header_box" }, [
                  _c("div", [
                    _c("img", {
                      attrs: {
                        src: _vm.dealColorFn(items.type).imgUrl,
                        align: "bottom",
                        alt: "",
                      },
                    }),
                    _c(
                      "span",
                      { style: { color: _vm.dealColorFn(items.type).color } },
                      [_vm._v(_vm._s(_vm.dealColorFn(items.type).name))]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "content-box" }, [
                  _c(
                    "div",
                    { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                    _vm._l(items.list, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "complaints_list" },
                        [
                          item.menuItemCode != "JGW-1-4"
                            ? [
                                _c("cardList1", {
                                  attrs: {
                                    item: item,
                                    warnOptions: _vm.warnGradeList,
                                    historyid: item.historyid,
                                    type: _vm.dealColorFn(items.type),
                                  },
                                  on: { refreshData: _vm.searchData },
                                }),
                              ]
                            : [
                                _c("cardList2", {
                                  attrs: {
                                    item: item,
                                    warnOptions: _vm.warnGradeList,
                                    historyid: item.historyid,
                                    type: _vm.dealColorFn(items.type),
                                  },
                                  on: { refreshData: _vm.searchData },
                                }),
                              ],
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ]),
              ])
            }),
            0
          ),
          _c("div", { staticClass: "more_box", on: { click: _vm.jumpMore } }, [
            _c("img", {
              attrs: {
                src: require("@/assets/img/cockpit/warn/more.png"),
                alt: "",
              },
            }),
            _vm._v(" 查看更多"),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }